export default "__VITE_ASSET__tQMLcTgX__"